import styled from "styled-components";
import { colors, device } from "../styles/stylesConfig";
import { memo } from "react";

const Hamburger = styled.label`
    width: 30px;
    height: fit-content;
    cursor: pointer;
    position: absolute;
    visibility: hidden;
    z-index: 2; 
    justify-self: end;

    @media ${device.lg} {
        visibility: visible;
        position: relative;
    }

    @media ${device.sm} {
        width: 30px; 
    }

    & > input {
        display: none;
    }

    & > span {
        display: block;
        position: relative;
        height: 2px;
        width: 100%;
        background-color: ${colors.primary};
        border-radius: 10px;
        opacity: 1;
        left: 0;
        margin-bottom: 8px;
        transition: 0.3s ease-in-out;

        &:last-of-type {
            margin-bottom: 0;
        }

    }
    & > span {
        transform-origin: left center;
    }
    & > input:checked ~ span {
        background: white;
        top: 5px;
        left: 5px;
        margin-bottom: 28%;
    }
    & > input:checked ~ span:nth-of-type(1) {
        transform: rotate(45deg);
    }
    & > input:checked ~ span:nth-of-type(2) {
        opacity: 0;
    }
    & > input:checked ~ span:nth-of-type(3) {
        transform: rotate(-45deg);
    }

`

interface Props {
    showMenu: boolean;
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>
}

const MenuButtonComponent = ({ showMenu, setShowMenu }: Props) => {

    return (

        <Hamburger>
            <input type="checkbox" checked={showMenu} onChange={() => setShowMenu(!showMenu)} />
            <span></span>
            <span></span>
            <span></span>
        </Hamburger>

    )
}

const MenuButton = memo(MenuButtonComponent);

export default MenuButton;